/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as appStrings from '@touchplan/strings';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from 'src/app/modules/projects2/projects2.interfaces';
import { DependencyLinkageType } from 'src/app/app-data/models/DependencyLinkageType';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export interface ITicketDependencyEditData extends GenericDialogData {
	linkageType: DependencyLinkageType;
	lagDays: number;
}

interface ITicketDependencyDialogData extends GenericDialogData {
	editData: ITicketDependencyEditData;
	includeCancelButton: boolean;
}

@Component({
	selector: 'ticket-dependency-dialog',
	templateUrl: './ticket-dependency-dialog.component.html',
	styleUrls: ['./ticket-dependency-dialog.component.scss'],
})
export class TicketDependencyDialogComponent implements OnInit {
	public appStrings = appStrings;
	public dialogData: ITicketDependencyDialogData;

	public newLag;

	public editDependencyGroup: UntypedFormGroup;
	public readonly typeOptions = [
		{ value: DependencyLinkageType.FinishToStart, label: appStrings.LINKAGE_TYPE_FINISH_TO_START },
		{ value: DependencyLinkageType.StartToStart, label: appStrings.LINKAGE_TYPE_START_TO_START },
		{ value: DependencyLinkageType.FinishToFinish, label: appStrings.LINKAGE_TYPE_FINISH_TO_FINISH },
		{ value: DependencyLinkageType.StartToFinish, label: appStrings.LINKAGE_TYPE_START_TO_FINISH },
	];

	public static open(
		dialog: MatDialog,
		linkageType: DependencyLinkageType,
		lagDays: number,
		includeCancelButton: boolean
	) {
		const data = {
			title: appStrings.EDIT_DEPENDENCY_TITLE,
			editData: {
				linkageType,
				lagDays,
			},
			includeCancelButton,
		} as ITicketDependencyDialogData;

		return dialog.open(TicketDependencyDialogComponent, { data, autoFocus: false });
	}

	constructor(
		public dialogRef: MatDialogRef<TicketDependencyDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.dialogData = data;
		this.newLag = data.editData.lagDays + 1;
	}

	public ngOnInit() {
		this.editDependencyGroup = new UntypedFormGroup({
			type: new UntypedFormControl(this.dialogData.editData.linkageType),
			lag: new UntypedFormControl(this.dialogData.editData.lagDays),
		});
	}

	public handleCancel(): void {
		this.dialogRef.close();
	}

	public handleSave(): void {
		const resultData: ITicketDependencyEditData = {
			linkageType: this.editDependencyGroup.get('type').value,
			lagDays: this.editDependencyGroup.get('lag').value,
		};
		this.dialogRef.close(resultData);
	}
}
